import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import ConditionBuilder from './ConditionBuilder';

const RuleConditions = ({ match, onChange, ...props }) => {
  const [advanced, setAdvanced] = useState(false);
  const anyOnly = !match.all.length && match.any.length > 0;
  const both = match.all.length > 0 && match.any.length > 0;
  return (
    <>
      {(advanced || !anyOnly) && (
        <ConditionBuilder
          {...props}
          title="All of these are true"
          conditions={match.all}
          onChange={all => onChange({ ...match, all })}
        />
      )}
      {(advanced || match.any.length > 0) && (
        <ConditionBuilder
          {...props}
          title="Any of these are true"
          conditions={match.any}
          onChange={any => onChange({ ...match, any })}
        />
      )}
      {anyOnly && !advanced && !props.disabled && (
        <Button
          type="button"
          variant="link"
          size="sm"
          className="mb-3"
          onClick={() => onChange({ all: match.any, any: [] })}
        >
          Switch to: all of these must be true
        </Button>
      )}
      {!advanced && !both && !props.disabled && (
        <Button
          type="button"
          variant="link"
          size="sm"
          className="mb-3"
          onClick={() => setAdvanced(true)}
        >
          {anyOnly
            ? 'Advanced: also require all of…'
            : 'Advanced: also require at least one of…'}
        </Button>
      )}
    </>
  );
};
export default RuleConditions;
